const STORAGE_KEY_PREFIX = 'lastAreaId-';

/**
 * Hook for managing the last selected area ID in sessionStorage.
 * Centralizes the storage key and operations to avoid typos.
 */
export const useLastAreaId = (propertyAssociationId: string | undefined) => {
    const storageKey = propertyAssociationId ? `${STORAGE_KEY_PREFIX}${propertyAssociationId}` : null;

    const getLastAreaId = (): string | null => {
        if (!storageKey) {
            return null;
        }
        return sessionStorage.getItem(storageKey);
    };

    const setLastAreaId = (areaId: string): void => {
        if (!storageKey) {
            return;
        }
        sessionStorage.setItem(storageKey, areaId);
    };

    const clearLastAreaId = (): void => {
        if (!storageKey) {
            return;
        }
        sessionStorage.removeItem(storageKey);
    };

    return { getLastAreaId, setLastAreaId, clearLastAreaId };
};

/**
 * Clears all lastAreaId entries from sessionStorage.
 * Useful when navigating to the home page.
 */
export const clearAllLastAreaIds = (): void => {
    const keysToRemove = Object.keys(sessionStorage).filter((key) => key.startsWith(STORAGE_KEY_PREFIX));
    keysToRemove.forEach((key) => sessionStorage.removeItem(key));
};
